import React, { useState, useEffect } from "react";
import "./cart.css";
import NavbarCustom from "../../Components/NavbarCustom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { useNewUser } from "../../APIContext/NewUserContext";
import { useNavigate } from "react-router-dom";
import img from "../../Assets/Images/Baseball/baseball_1.png";

export const Cart = () => {
  const navigate = useNavigate();
  const { fetchCartItemsNew, removeFromCartNew } = useNewUser();
  const [cartData, setCartData] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const fetchCart = async () => {
    try {
      const res = await fetchCartItemsNew();
      setCartData(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCart();
  }, [refresh]);

  const handleRemove = async (id) => {
    try {
      await removeFromCartNew(id);
      setRefresh((prev) => !prev);
    } catch (err) {
      console.error(err);
    }
  };

  if (!cartData) return null;

  const { items = [], summary = {} } = cartData;

  return (
    <>
      <NavbarCustom />

      <div className="buy-cart-sports-container">
        {/* Header */}
        <div className="buy-cart-header">
          <BackBtn />
          <div className="buy-cart-header-content">
            <h1 className="buy-cart-heading black-text-clip">
              Your Cart Items
            </h1>
          </div>
        </div>

        {/* Cart Table */}
        <div className="cart-table">
          <div className="cart-table-header mobile-label-cart-hide">
            <span>PRODUCT</span>
            <span>DESCRIPTION</span>
            <span>CHILD</span>
            <span className="cart-price">TOTAL</span>
          </div>

          {items.length === 0 ? (
            <p className="black-text-clip" style={{ padding: "16px" }}>
              Your cart is empty
            </p>
          ) : (
            items.map((item) => (
              <div className="cart-table-row" key={item.id}>
                <div className="cart-img filter-brightness">
                  <img src={item.package_image || item.sport_image || img} />
                </div>
                <div className="cart-description">
                  <p className="black-text-clip">
                    <strong>Name :</strong> {item.package_name}
                  </p>
                  <p className="black-text-clip">
                    <strong>Type Name :</strong>{" "}
                    {item.session_count?.label || "-"}
                  </p>
                  <p className="black-text-clip">
                    <strong>No of Sessions :</strong>{" "}
                    {item.session_count?.value || "-"}
                  </p>
                </div>

                {item.child_details ? (
                  <div className="cart-description">
                    <p className="black-text-clip">
                      <strong>Name :</strong> {item.child_details?.name || "-"}
                    </p>
                    <p className="black-text-clip">
                      <strong>Gender :</strong>{" "}
                      {item.child_details?.gender || "-"}
                    </p>
                    <p className="black-text-clip">
                      <strong>Grade :</strong>{" "}
                      {item.child_details?.grade || "-"}
                    </p>
                    <p className="black-text-clip">
                      <strong>Jersey Size :</strong>{" "}
                      {item.child_details?.jersey_size || "-"}
                    </p>
                    <p className="black-text-clip">
                      <strong>School :</strong>{" "}
                      {item.child_details?.school_name || "-"}
                    </p>
                  </div>
                ) : (
                  <div className="cart-description">
                    <p className="black-text-clip">
                      <strong>Any Child</strong>
                    </p>
                  </div>
                )}

                <div className="cart-price">
                  <span className="black-text-clip text-right">
                    <strong className="mobile-label-cart-show">Total : </strong>
                    ${item.total_price || 0}
                  </span>
                  <button
                    className="cart-delete-btn"
                    onClick={() => handleRemove(item.id)} // ✅ FIXED
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </div>
              </div>
            ))
          )}

          <div className="cart-total-row">
            <span className="black-text-clip">CART TOTAL</span>
            <span className="black-text-clip text-right">
              ${summary?.subtotal || 0}
            </span>
          </div>
        </div>

        <div className="p-submit-button-container" style={{ padding: 0 }}>
          <button
            disabled={items.length === 0}
            type="button"
            className="p-submit-button"
            onClick={() => navigate("/checkout")}
          >
            Proceed to Checkout{" "}
            <i className="ri-shopping-cart-2-fill cart-icon"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default Cart;
